var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.999 10.04a1 1 0 0 1-.946 1.052c-.752.04-1.349.089-1.814.138-.626.066-1.006.45-1.07 1.003C5.08 13.027 5 14.228 5 16c0 1.772.079 2.973.17 3.767.063.554.442.937 1.067 1.003C7.33 20.885 9.139 21 12 21c2.86 0 4.67-.115 5.763-.23.625-.066 1.004-.45 1.067-1.003.091-.794.17-1.995.17-3.767 0-1.772-.079-2.973-.17-3.767-.063-.553-.443-.937-1.068-1.003a35.394 35.394 0 0 0-1.815-.138 1 1 0 0 1 .106-1.997c.783.041 1.414.093 1.918.146 1.485.157 2.669 1.21 2.846 2.765.102.886.183 2.165.183 3.994 0 1.828-.081 3.108-.183 3.994-.177 1.554-1.358 2.608-2.844 2.765-1.181.124-3.062.241-5.973.241-2.91 0-4.792-.117-5.973-.241-1.485-.157-2.667-1.21-2.844-2.765C3.08 19.108 3 17.828 3 16c0-1.829.081-3.108.183-3.994.177-1.555 1.361-2.608 2.846-2.765a37.358 37.358 0 0 1 1.918-.146 1 1 0 0 1 1.052.945Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.207 6.207a1 1 0 0 1-1.414-1.414l3.5-3.5a1 1 0 0 1 1.414 0l3.5 3.5a1 1 0 0 1-1.414 1.414L13 4.414V14a1 1 0 1 1-2 0V4.414L9.207 6.207Z",
    fill: "#777E91"
  })));
};
export default SvgLine;